'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _lib = require('../../helpers/lib');

var _Constant = require('../../helpers/Constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopCard = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopCard, _Component);

  function ShopCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShopCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShopCard.__proto__ || (0, _getPrototypeOf2.default)(ShopCard)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShopCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./ShopCard.scss');
      var shop = this.props.shop;

      var none = shop ? false : true;
      var checkProps = shop ? false : true;
      var newReview = shop && shop.reviews && shop.reviews.length > 0 ? shop.reviews[shop.reviews.length - 1] : null;
      var avt = _Constant.defaultAvatar;
      if (newReview) {
        avt = (0, _lib.getAvatar)(newReview.user);
      }
      var reviews = shop && shop.reviews || [];
      // chỉ lấy những review được chấp nhận
      var averagePoint = shop && shop.averagePoint || 0;
      var reviewGuest = false;
      if (!none && reviews.length === 0 && shop.review_guest) {
        reviewGuest = true;
        avt = _Constant.defaultAvatar;
      }
      var stylePoint = {
        borderColor: (0, _lib.getColorRatingCode)(averagePoint),
        backgroundColor: averagePoint === 0 ? (0, _lib.getColorRatingCode)(0) : '#14BBBA'
      };
      var thumbnailStyle = {
        backgroundImage: 'url(\'' + avt + '\')',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
      var renderContent = void 0;
      if (shop) {
        renderContent = _react2.default.createElement(
          'div',
          { className: styles.productInfo },
          _react2.default.createElement(
            'div',
            { className: styles.primary },
            _react2.default.createElement(
              'div',
              { className: styles.textTwoLine },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: styles.name, to: '/' + shop.handle },
                shop.name
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.address,
                title: shop.addressDisplay ? shop.addressDisplay : shop.address
              },
              shop.addressDisplay ? shop.addressDisplay : shop.address
            ),
            _react2.default.createElement(
              'div',
              { className: styles.summary },
              _react2.default.createElement(
                'div',
                { className: styles.totalLike },
                _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'heart' }),
                shop.total_like ? shop.total_like : 0
              ),
              _react2.default.createElement(
                'div',
                { className: styles.totalComment },
                _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'comment' }),
                reviews.length ? reviews.length : 0
              )
            )
          ),
          !newReview && !reviewGuest ? _react2.default.createElement(
            'div',
            { className: styles.review },
            _react2.default.createElement(
              'p',
              { className: styles.noneReview },
              'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 b\xECnh lu\u1EADn n\xE0o.',
              _react2.default.createElement('br', null),
              'Click v\xE0o',
              ' ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/' + shop.handle, className: styles.link },
                '\u0111\xE2y'
              ),
              ' ',
              '\u0111\u1EC3 tr\u1EDF th\xE0nh ng\u01B0\u1EDDi \u0111\u1EA7u ti\xEAn \u0111\xF3ng g\xF3p b\xECnh lu\u1EADn.'
            )
          ) : _react2.default.createElement(
            'div',
            { className: styles.review },
            _react2.default.createElement(
              'div',
              { className: styles.avatarGroup },
              _react2.default.createElement('div', {
                className: styles.avatarComment,
                style: thumbnailStyle
              })
            ),
            reviewGuest ? _react2.default.createElement(
              'div',
              { className: styles.contentComment },
              _react2.default.createElement(
                'div',
                { className: styles.groupNameTime },
                _react2.default.createElement(
                  'span',
                  { className: styles.commentName },
                  shop.review_guest.name || 'Guest'
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.commentTime },
                  ' ',
                  (0, _lib.renderTime)(shop.review_guest.createdAt)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.commentTitle },
                shop.review_guest.comment
              )
            ) : _react2.default.createElement(
              'div',
              { className: styles.contentComment },
              _react2.default.createElement(
                'div',
                { className: styles.groupNameTime },
                _react2.default.createElement(
                  'span',
                  { className: styles.commentName },
                  newReview.user && newReview.user.profile && newReview.user.profile.name || ''
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.commentTime },
                  ' ',
                  newReview.created ? (0, _lib.renderTime)(newReview.created) : (0, _lib.renderTime)(newReview.createdAt)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.commentTitle },
                newReview.comment
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.point, style: stylePoint },
            averagePoint !== 0 ? averagePoint : '--'
          )
        );
      } else {
        renderContent = _react2.default.createElement(
          'div',
          { className: styles.productInfo },
          _react2.default.createElement(
            'div',
            { className: styles.primary },
            _react2.default.createElement('div', { className: styles.name }),
            _react2.default.createElement('div', { className: styles.address })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.review },
            _react2.default.createElement(
              'div',
              { className: styles.avaComment },
              _react2.default.createElement('img', { src: '', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.comment },
              _react2.default.createElement(
                'div',
                { className: styles.commentTop },
                _react2.default.createElement('div', { className: styles.commentName }),
                _react2.default.createElement('div', { className: styles.commentTime })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.commentBottom },
                _react2.default.createElement('div', { className: styles.commentTitle })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.summary },
              _react2.default.createElement('div', { className: styles.totalLike }),
              _react2.default.createElement('div', { className: styles.totalComment })
            )
          ),
          _react2.default.createElement('div', { className: styles.point })
        );
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.product + (checkProps ? ' ' + styles.noneProduct : '')
        },
        _react2.default.createElement(
          'div',
          { className: styles.productImage },
          shop && shop.image && _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.name, to: '/' + shop.handle },
            _react2.default.createElement('img', {
              src: (0, _lib.getUrlImage)(shop.image),
              alt: shop.name,
              onError: this.onErrorImage
            })
          )
        ),
        renderContent
      );
    }
  }]);
  return ShopCard;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object,
  user: _react.PropTypes.object,
  notComment: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = ShopCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/ShopCard.js
// module id = 144
// module chunks = 0